import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Article from "@/pages/Article";
import Rankings from "@/pages/Rankings";
import ArtistProfile from "@/pages/ArtistProfile";
import Studio from "@/pages/Studio";
import AdvertorialStudio from "@/pages/AdvertorialStudio";
import Advertorials from "@/pages/Advertorials";
import Advertorial from "@/pages/Advertorial";
import Advertise from "@/pages/Advertise";
import AdminLeads from "@/pages/AdminLeads";
import AdminAds from "@/pages/AdminAds";
import AdminCommunity from "@/pages/AdminCommunity";
import AdminRankings from "@/pages/AdminRankings";
import AdminPosts from "@/pages/AdminPosts";
import Community from "@/pages/Community";
import Login from "@/pages/Login";
import ProtectedRoute from "@/components/ProtectedRoute";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import Watch from "@/pages/Watch";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="bottom-left" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/c/:slug" element={<Category />} />
              <Route path="/article/:slug" element={<Article />} />
              <Route path="/rankings" element={<Rankings />} />
              <Route path="/rankings/:region" element={<Rankings />} />
              <Route path="/watch" element={<Watch />} />
              <Route path="/community" element={<Community />} />
              <Route path="/artist/:slug" element={<ArtistProfile />} />
              <Route path="/login" element={<Login />} />
              <Route path="/studio" element={<ProtectedRoute><Studio /></ProtectedRoute>} />
              <Route path="/studio/advertorial" element={<ProtectedRoute><AdvertorialStudio /></ProtectedRoute>} />
              <Route path="/advertorials" element={<Advertorials />} />
              <Route path="/advertorial/:slug" element={<Advertorial />} />
              <Route path="/advertise" element={<Advertise />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/leads" element={<ProtectedRoute><AdminLeads /></ProtectedRoute>} />
              <Route path="/admin/ads" element={<ProtectedRoute><AdminAds /></ProtectedRoute>} />
              <Route path="/admin/community" element={<ProtectedRoute><AdminCommunity /></ProtectedRoute>} />
              <Route path="/admin/rankings" element={<ProtectedRoute><AdminRankings /></ProtectedRoute>} />
              <Route path="/admin/posts" element={<ProtectedRoute><AdminPosts /></ProtectedRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
